module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAfklEQVR4Ae3OAQaAUBBF0Um12AD4CGgrQQICaXs3EWV8gWo+3uGBGVwzERERMWA4VkpM4pKKiQmP8jFOio7ZjvmoqJgVaM+tPioiprndm9+iMjHLPcZFLT7q65gZqB/+60+jgN7FVJbno2Yuvb0J6IAxH5MHVMAEdBZDREREdpuyWm7X7JgBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/expandLess.png
// module id = 363
// module chunks = 0